import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";
import { PaymentRequestsResponse } from "../interfaces/payment-requests.interface";

@Injectable()
export class PlatesPaymentRequestsService {
  constructor(private http: HttpClientService) {}

  public createPaymentRequest(values: Record<string, unknown>): Observable<any> {
    return this.http
      .post("/api/plate_payments/", { debt_request: values })
      .pipe(tap((_) => console.log("PlatesPaymentRequestsService.createPaymentRequest: Ok.")));
  }

  public getAllPaymentRequests(filter: any = {}): Observable<PaymentRequestsResponse> {
    return this.http.get("/api/plate_payments/payment_requests/", { params: filter }).pipe(
      map((response: any) => response as PaymentRequestsResponse),
      tap((_) => console.log("PlatesPaymentRequestsService.getAllPaymentRequests: Ok."))
    );
  }

  public updatePaymentRequest(id: number, values: Record<string, unknown>): Observable<any> {
    return this.http
      .put(`/api/plate_payments/${id}`, { plate_payment: values })
      .pipe(tap((_) => console.log("PlatesPaymentRequestsService.updatePaymentRequest: Ok.")));
  }
}
